import * as React from 'react';
import styled from 'styled-components';
import { Spinner } from 'react-activity';

import IViewProps from '../../IViewProps';
import Colors from '../../lib/Colors';
import ButtonFooter from '../ButtonFooter';
import CardWithHeader from '../CardWithHeader';
import RewardButton from './RewardButton';
import IReward from 'src/lib/types/Reward';
import SmilesIcon from '../icons/SmilesIcon';
import CreditDisplay from '../CreditDisplay';

function Footer(
  props: IViewProps,
  isFavorited: boolean,
  hasEnoughCredit: boolean,
  isAuthenticated: boolean,
  canRedeemToday: boolean,
) {
  let icon = null;
  if (props.isSettingFavoriteRewardId) {
    icon = <Spinner size={10} />;
  } else {
    icon = isFavorited ? '❤️' : '♡';
  }

  let content;
  if (isAuthenticated) {
    if (!canRedeemToday) {
      content =
          <div className="help-text">Du hast diese Woche bereits eine Prämie eingelöst.
              Komm nächste Woche wieder.</div>;
    } else if (hasEnoughCredit) {
      content = <button onClick={props.onShowAddressEditor}>Jetzt kaufen</button>;
    } else {
      // 'Set favorite' button
      content = <button
        className="inverted"
        onClick={props.setRewardAsFavorite}
        disabled={isFavorited}
      >
        <span>
          {isFavorited
            ? 'Diese Prämie ist Deine Wunschprämie!'
            : 'Als Wunschprämie setzen'}
        </span>&nbsp;
        <span>{icon}</span>
      </button>;
    }
  } else {
    // tslint:disable-next-line:max-line-length
    const reward: IReward | undefined = props.rewards.find(r => r.isActive && r.id === props.rewardId);
    const amount = reward ?
      <span className="amount">{reward.amount} <SmilesIcon /></span>
      : 'Smiles';
    content = <>
      <div className="help-text">
        Logge Dich ein und sammle {amount}, um diese Prämie zu erhalten!
      </div>
      <button onClick={props.onLogin}>Jetzt Einloggen</button>
    </>;
  }

  return <ButtonFooter>{content}</ButtonFooter>;
}

function UnstyledRewardCategoryView(props: IViewProps) {
  const { rewardCategoryId } = props;
  const rewardCategory = props.rewardCategories.find(
    r => r.isActive && r.id === rewardCategoryId,
  );
  if (!rewardCategory) {
    return null;
  }
  const rewardsInCategory = props.rewards
    .filter(r => r.isActive && r.rewardCategoryId === rewardCategoryId)
    .sort((a, b) => a.amount - b.amount);

  const selectedReward = props.rewards.find(r => r.isActive && r.id === props.rewardId);
  const hasEnoughCredit = !!(
    selectedReward &&
    props.credits &&
    props.credits >= selectedReward.amount &&
      (!selectedReward.vipAmount || selectedReward.vipAmount === 0 || (props.vipCredits &&
    props.vipCredits >= selectedReward.vipAmount))
  );
  const isFavorited = !!(
    selectedReward && props.favoriteRewardId === selectedReward.id
  );
  const isAuthenticated = props.isAuthenticated || false;
  const canRedeemToday = props.canRedeemToday || false;
  console.log(`Can redeem today ? ${canRedeemToday}`);
  const rewardName = selectedReward && selectedReward.name;

  const footer = Footer(props, isFavorited, hasEnoughCredit, isAuthenticated, canRedeemToday);
  const title = <>
    <div className="title">{rewardCategory.name}</div>
    {props.isAuthenticated &&
    <CreditDisplay label="" amount={props.credits!}/>}
  </>;
  return (
    <CardWithHeader
      className={props.className}
      title={title}
      footer={footer}
      onGoBack={props.onGoBack}
    >
      <section
        className="reward-image"
        style={{ backgroundColor: Colors.background }}
      >
        <img
          src={
            (selectedReward && selectedReward.imageUrl) ||
            rewardCategory.imageUrl
          }
          alt={rewardName}
        />
      </section>

      {isAuthenticated && rewardsInCategory.length > 1 &&
      <section className="description"><header><span>Du hast {props.credits}
        <SmilesIcon fillColor={Colors.mutedText} /> auf Deinem Konto,
         die Du einlösen kannst. Wähle eine Variante aus:</span>
      </header></section>}

      <section className="rewards">
        <ul>
          {rewardsInCategory.map(reward => (
            <li key={reward.id}>
              <RewardButton
                reward={reward}
                onClick={() => props.onSelectReward(reward.id)}
                isSelected={reward.id === props.rewardId}
                isFavorited={reward.id === props.favoriteRewardId}
                isAuthenticated={props.isAuthenticated || false}
                userCredits={props.credits || 0}
                userVipCredits={props.vipCredits || 0}
              />
            </li>
          ))}
        </ul>
      </section>

      <section className="description">
        {(selectedReward && selectedReward.description) ||
          rewardCategory.description}
      </section>
    </CardWithHeader>
  );
}

const SingleRewardCategoryView = styled(UnstyledRewardCategoryView)`
  display: flex;
  flex-direction: column;

  section.reward-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      max-width: 20rem;
      margin: 0.5rem;
      max-height: 25vh;
    }
  }

  section.description {
    padding: 0.5rem 1.2rem;
    font-size: 0.9rem;
    line-height: 1.333;
    color: ${Colors.mutedText};
  }

  section.rewards {
    padding: 0.5rem;
    > header {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin: 0.6rem;
    }
    > ul {
      display: flex;
      justify-content: space-evenly;
      flex: 1;
      flex-wrap: wrap;
      list-style-type: none;
      padding: 0;
      margin: 1rem 0 0 0;
      li {
        margin: 0;
        padding: 0;
      }
    }
  }

  > footer {
    flex-direction: column;
    max-height: unset;
    height: unset;

    .amount {
      white-space: nowrap;
    }

    .help-text {
      margin: 0 0.75rem 0.5rem;
    }

    button {
      min-height: 2.5rem;
      &:disabled {
        border: none;
        color: #666;
        opacity: 1;
      }
    }
  }
`;
export default SingleRewardCategoryView;



// WEBPACK FOOTER //
// ./src/components/SingleRewardCategoryView/SingleRewardCategoryView.tsx